export class TenantModel {
   id: string;
   name: string;
   isDefault: boolean;
   memberSid: string;
}
